<section id="summary">
  <mh-wait-chain *ngIf="waiting" [currentChain]="currentChain" [block]="callingInterchain" [total]="totalSizeChain" [totalBlock]="totalSizeBlock" [error]="error"></mh-wait-chain>
  <ng-container *ngIf="!waiting" >
    <mh-interchain-prestay-table [hasActiveServices]="hasActiveServices" [hasActiveWebcheckin]="hasActiveWebcheckin" [dataSource]="dataSource" [customersDetails]="customersDetails"></mh-interchain-prestay-table>
  </ng-container>

</section>
